// extracted by mini-css-extract-plugin
export var reviewSection = "reviewSection-module--reviewSection--veHpD";